export interface Zone {
  id: string;
  slug: string;
  name: string;
  subtitle: string;
  description: string;
  cover: string;
  count: number;
  updatedAt: string;
  tags: string[];
  category: string;
  hot: boolean;
  tone: "primary" | "accent" | "secondary";
}

export const zoneCategories = ["全部", "影视", "综艺", "音乐", "网络", "榜单"];

export const zones: Zone[] = [
  {
    id: "z1",
    slug: "hot-drama",
    name: "热剧速递",
    subtitle: "追剧不掉队",
    description:
      "把当期热度最高的剧集内容整理成合集，包含名场面复盘、伏笔梳理、剧集口碑变化三类板块，一页看完一条剧的讨论脉络。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20editorial%20still%20of%20a%20vintage%20television%20set%20and%20stacked%20film%20reels%20on%20a%20wooden%20table%2C%20soft%20amber%20lighting%2C%20muted%20cream%20background%2C%20entertainment%20magazine%20feature%20photography%2C%20shallow%20depth%20of%20field%2C%20elegant%20composition&width=1200&height=800&seq=zone-hot-drama-91&orientation=landscape",
    count: 328,
    updatedAt: "2026-09-09",
    tags: ["名场面", "伏笔", "口碑"],
    category: "影视",
    hot: true,
    tone: "primary",
  },
  {
    id: "z2",
    slug: "variety-fun",
    name: "综艺吃瓜",
    subtitle: "名梗一次笑够",
    description:
      "综艺名梗、嘉宾互动、剪辑取舍都收在这一块。按节目分期归档，热门的桥段单独成条，找梗不用再翻整季。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20editorial%20flat%20lay%20with%20colorful%20stage%20spotlights%2C%20a%20megaphone%20and%20confetti%20on%20warm%20cream%20paper%20background%2C%20energetic%20variety%20show%20themed%20still%20life%2C%20soft%20studio%20lighting%2C%20magazine%20style%20composition&width=1200&height=800&seq=zone-variety-91&orientation=landscape",
    count: 264,
    updatedAt: "2026-09-08",
    tags: ["名梗", "嘉宾", "剪辑"],
    category: "综艺",
    hot: true,
    tone: "accent",
  },
  {
    id: "z3",
    slug: "behind-scene",
    name: "影视幕后",
    subtitle: "镜头之外的事",
    description:
      "探班、道具、造型、置景，讲清楚一部作品在开拍前后都发生了什么。适合想了解制作流程的读者慢慢看。",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20a%20clapperboard%2C%20camera%20lens%20and%20director%20chair%20in%20warm%20sepia%20tones%2C%20dramatic%20soft%20lighting%2C%20vintage%20cinema%20aesthetic%2C%20editorial%20magazine%20photography%2C%20cream%20backdrop&width=1200&height=800&seq=zone-behind-91&orientation=landscape",
    count: 176,
    updatedAt: "2026-09-06",
    tags: ["道具", "造型", "置景"],
    category: "影视",
    hot: false,
    tone: "secondary",
  },
  {
    id: "z4",
    slug: "music-live",
    name: "音乐现场",
    subtitle: "现场感拉满",
    description:
      "舞台直拍、live 片段、歌单盘点集中在这。按演出与曲目归档，配合机位与收音的解读，看懂现场为什么更好听。",
    cover:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20a%20silhouetted%20microphone%20stand%20and%20warm%20amber%20stage%20lights%2C%20glowing%20bokeh%20crowd%20lights%2C%20moody%20editorial%20music%20photography%2C%20cream%20and%20gold%20tones%2C%20magazine%20feature%20still&width=1200&height=800&seq=zone-music-91&orientation=landscape",
    count: 142,
    updatedAt: "2026-09-07",
    tags: ["直拍", "现场", "歌单"],
    category: "音乐",
    hot: false,
    tone: "accent",
  },
  {
    id: "z5",
    slug: "web-trends",
    name: "网络热梗",
    subtitle: "这周都在说啥",
    description:
      "一周网络热词与热门片段的合集，记录每个梗的出处、用法和消退速度。想快速跟上话题，从这里开始最省时间。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20still%20life%20with%20a%20smartphone%2C%20speech%20bubble%20cards%20and%20emoji%20tokens%20on%20a%20warm%20off%20white%20desk%2C%20soft%20daylight%2C%20internet%20trend%20concept%2C%20clean%20magazine%20composition%2C%20muted%20warm%20palette&width=1200&height=800&seq=zone-memes-91&orientation=landscape",
    count: 388,
    updatedAt: "2026-09-09",
    tags: ["热词", "出处", "用法"],
    category: "网络",
    hot: true,
    tone: "primary",
  },
  {
    id: "z6",
    slug: "ranking-list",
    name: "榜单盘点",
    subtitle: "数字会说话",
    description:
      "收视、热度、口碑、话题量多维榜单汇总，每期附上变化解读，看清一份榜单背后到底是内容好还是排播巧。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20golden%20trophy%2C%20numbered%20ranking%20cards%20and%20a%20notebook%20on%20warm%20cream%20background%2C%20chart%20and%20ranking%20concept%2C%20soft%20studio%20lighting%2C%20premium%20magazine%20photography%2C%20amber%20accents&width=1200&height=800&seq=zone-ranking-91&orientation=landscape",
    count: 96,
    updatedAt: "2026-09-05",
    tags: ["收视", "热度", "口碑"],
    category: "榜单",
    hot: false,
    tone: "secondary",
  },
];